import angular from 'angular'
import routers from './routers.js'
import declarationGenerationCtrl from './declarationGenerationCtrl'

export default angular
  .module('declaration.vatDeclarationSurcharges.declarationGeneration', [])
  .config([
    '$stateProvider',
    ($stateProvider) => {
      Object.keys(routers).forEach((router) => {
        $stateProvider.state(routers[router].state, routers[router].config)
      })
    },
  ])
  .controller('declarationGenerationCtrl', declarationGenerationCtrl).name



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/declarationGeneration/index.js